import { render, staticRenderFns } from "./GsaObject.vue?vue&type=template&id=b048dad2&"
import script from "./GsaObject.vue?vue&type=script&lang=js&"
export * from "./GsaObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports